import type * as React from 'react';
import { del } from '@Domain/Api';
import userDeleted, { type UserDeletedAction } from '@Application/Users/Users/Actions/userDeleted';
import userDeletionFailed, {
	type UserDeletionFailedAction,
} from '@Application/Users/Users/Actions/userDeletionFailed';
import type DeleteUser from '@Application/Users/Users/Commands/DeleteUser';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = UserDeletedAction | UserDeletionFailedAction;

export default (command: DeleteUser) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			await del<void>(
				`${parameters.api.host}/api/accounts/${command.accountId}/users/${command.userId}`,
			);

			const action = userDeleted({ userId: command.userId }, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = userDeletionFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
